import styled from 'styled-components';
import StyleData from '../../../utilities/StyleData';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const HelperText = styled.div`
  display: flex;
  flex-direction: column;
  font-family: ${StyleData.font.secondary};
  font-size: ${StyleData.fsize.sm};
  color: ${StyleData.color.lightText};
`;

export const DocumentList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 14px;
`;

export const DocumentRow = styled.li<{ isDeleted?: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 18px;
  border: 1px solid ${StyleData.color.smoothGrey};
  border-radius: 50px;
  background-color: ${StyleData.color.lightGrey};
  opacity: ${(p) => (p.isDeleted ? 0.5 : 1)};
`;

export const DocumentInfo = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-width: 0;

  span.name {
    font-family: ${StyleData.font.secondary};
    font-size: ${StyleData.fsize.md};
    font-weight: 500;
    color: ${StyleData.color.text};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
  }

  span.size {
    font-family: ${StyleData.font.secondary};
    font-size: ${StyleData.fsize.sm};
    color: ${StyleData.color.lightText};
    white-space: nowrap;
  }
`;

export const DocumentActions = styled.div`
  display: flex;
  align-items: center;
  color: ${StyleData.color.text};

  button {
    background: none;
    border: none;
    padding: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    color: inherit;
  }
  button:disabled {
    cursor: not-allowed;
    opacity: 0.4;
  }
  svg {
    width: 18px;
    height: 18px;
  }
  svg .st0-fill {
    fill: currentColor;
  }
`;

export const ActionsRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
`;

export const HiddenFileInput = styled.input`
  display: none;
`;

export const ErrorMessage = styled.p`
  color: ${StyleData.color.primary};
  font-family: ${StyleData.font.secondary};
  font-size: ${StyleData.fsize.sm};
  margin: 4px 0 0 0;
`;
